var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.825 4.675A.823.823 0 0 0 11 3.85a.823.823 0 0 0-.825.825v5.5h-5.5A.823.823 0 0 0 3.85 11c0 .457.368.825.825.825h5.5v5.5c0 .457.368.825.825.825a.823.823 0 0 0 .825-.825v-5.5h5.5A.823.823 0 0 0 18.15 11a.823.823 0 0 0-.825-.825h-5.5z"
  })));
};
export default SvgPlus;